module.exports = __webpack_public_path__ + "media/images/registrations-c25148b728a86a6e31d452cb6c7d36a3.png";